import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EChipsSelectMenuPlacement = {
	bottom: 'bottom',
	top: 'top',
	bottomEnd: 'bottom-end',
	topEnd: 'top-end',
} as const;

export type TChipsSelectMenuPlacement = TValueOfStringRecord<typeof EChipsSelectMenuPlacement>
